import { L1Object, L1ObjectObjective } from 'core/l1Object/L1Object';
import { DefaultL1ObjectManager } from 'core/l1Object/L1ObjectManager';
import { Order } from 'core/order/Order';
import _, { defaultTo } from 'lodash';
import { L1ObjectFormChannelModel } from './L1ObjectFormChannelModel';

export abstract class L1ObjectCreateFormChannelModel implements L1ObjectFormChannelModel {
  constructor(
    protected order: Order,
    protected l1ObjectManager = new DefaultL1ObjectManager()
  ) {}

  abstract get minBudget();

  abstract init(callback: (data) => void);

  abstract validate(value: Partial<L1Object>);

  abstract getCboChangeHint();

  abstract initChannelData(
    valueUpdater: (updateFunc: (prevValue: any) => any) => void
  );

  abstract onCBOChange(
    enable: boolean,
    valueUpdater: (updateFunc: (prevValue: any) => any) => void
  );

  abstract showRemainBudget(values: Partial<L1Object>);

  abstract toChannelNativeData(l1Object: L1Object, extraData: any): any;

  getDefaultBidStrategy = (channel?: string) =>
    this.l1ObjectManager.getDefaultCboBidStrategy(channel);
}

export class DefaultL1ObjectCreateFormChannelModel extends L1ObjectCreateFormChannelModel {
  constructor(
    protected order: Order,
    private useViewableImpressInReport: boolean
  ) {
    super(order);
  }

  get minBudget() {
    return this.order.campaignConstraint.budgetMinimum;
  }

  init = async (_1: (data) => void) => {
    // This is intentionally left empty.
  };

  initChannelData(valueUpdater: (updateFunc: (prevValue: any) => any) => void) {
    valueUpdater((prev) => {
      const prevRtb = defaultTo(prev.rtb, {});
      return {
        ...prev,
        objective: L1ObjectObjective.AWARENESS,
        budget: 0,
        autoOptimise: false,
        rtb: {
          ...prevRtb,
          bid_strategy: undefined,
          campaign_budgets: undefined,
          viewable_impress_report: this.useViewableImpressInReport
        }
      };
    });
  }

  validate = (_1: Partial<L1Object>) => {
    return {};
  };

  getCboChangeHint = () => '';

  onCBOChange(
    enable: boolean,
    valueUpdater: (updateFunc: (prevValue: any) => any) => void
  ) {
    if (enable) {
      valueUpdater((prev) => ({
        ...prev,
        budget: 0,
        rtb: {
          ...defaultTo(prev.rtb, {}),
          bid_strategy: this.getDefaultBidStrategy(prev.channel),
          campaign_budgets: undefined
        }
      }));
    } else {
      valueUpdater((prev) => ({
        ...prev,
        budget: 0,
        rtb: {
          ...defaultTo(prev.rtb, {}),
          bid_strategy: undefined,
          campaign_budgets: undefined
        }
      }));
    }
  }

  showRemainBudget(_values: Partial<L1Object>) {
    return true;
  }

  toChannelNativeData(l1Object: L1Object, extraData: any) {
    const order = extraData.order;
    const pmax3Objective = l1Object.objective;
    const objective = this.l1ObjectManager.getNativeObjectiveValue(
      l1Object.channel,
      pmax3Objective
    );
    return _.omitBy(
      {
        ..._.omit(l1Object, 'rtb'),
        objective,
        l1ObjectLifetimeBudget: _.isNil(l1Object.budget) ? 0 : l1Object.budget,
        adsOrderId: order.id,
        channelConfig: l1Object.rtb,
        channelGroupId: l1Object.channelGroupId
      },
      _.isUndefined
    );
  }
}
